import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { getHumanReadableIntervalDuration } from '@racemap/utilities/functions/getHumanReadableInterval';
import { Button } from 'antd';
import type { FC } from 'react';
import { staticThemeToken } from '../../../lib/theme';
import type { Range } from './rangeDraft';

interface Props {
  /** The pending range, so the length shown follows the panel rather than the saved value. */
  range: Range;
  canCommit: boolean;
  onOk: () => void;
  onCancel: () => void;
}

/** One confirmation for the whole range — antd offers only one per half. */
export const DraftFooter: FC<Props> = ({ range, canCommit, onOk, onCancel }) => {
  const [start, end] = range;
  // Shown live: it is what makes the end following the start visible rather than surprising.
  const duration = start != null && end != null ? end.diff(start) : null;

  return (
    <Container>
      {duration != null && <Duration>{getHumanReadableIntervalDuration(duration)}</Duration>}
      <Actions>
        <Button size="small" data-testid="date-range-picker-cancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          size="small"
          disabled={!canCommit}
          data-testid="date-range-picker-ok"
          onClick={onOk}
        >
          OK
        </Button>
      </Actions>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${staticThemeToken.marginXS}px;
  padding: ${staticThemeToken.paddingXXS}px 0;
`;

const Duration = styled.div`
  color: ${RacemapColors.DarkGray};
  white-space: nowrap;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${staticThemeToken.marginXS}px;
  /* Keeps the buttons right even when there is no duration to show. */
  margin-inline-start: auto;
`;
